import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";

class CustomerVehiclesList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      dataSource: [],
      users: [],
      selectedUser: "",
      selectedCustomer: "",
      customers: [],
      merchants: [],
      selectedMerchant: "",
      globalFilter: "",
      startDateFilter: null,
      endDateFilter: null,
      canWrite: false,
    };
    this.engine = new RequestEngine();
  }
  componentDidMount() {
    const storedMerchantId = sessionStorage.getItem("merchantId");
    const { selectedMerchant: stateMerchant, selectedCustomer: stateCustomer } =
      this.props.location.state || {};

    const selectedMerchant = stateMerchant || storedMerchantId || "";
    const selectedCustomer =
      stateCustomer || this.props.match.params.selectedCustomer || ""; // Get customer ID from URL
    const canWrite = this.hasPermission([Scopes.CUSTOMERS_VEHICLES_WRITE]);
    this.setState({ canWrite });

    if (selectedMerchant) {
      this.setState({ selectedMerchant, canWrite }, () => {
        this.fetchCustomers();
      });
    } else {
      this.fetchMerchants();
    }

    if (selectedCustomer) {
      this.setState({ selectedCustomer }, () => {
        this.fetchVehicles();
      });
    }
  }

  fetchMerchants = async () => {
    const response = await this.engine.getItem("merchants");
    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        merchants: response.data.items.map((merchant) => ({
          value: merchant.id,
          label: merchant.name,
        })),
      });
      if (this.state.merchants.length === 1) {
        this.setState({
          selectedMerchant: this.state.merchants[0].value,
        });
        this.fetchCustomers();
      }
    }
  };

  fetchCustomers = async () => {
    const { selectedMerchant, selectedCustomer } = this.state;

    if (!selectedMerchant) return;

    try {
      const response = await this.engine.getItem(
        `customers/${selectedMerchant}/users`
      );
      if (response && response.status === 200) {
        const customers = response.data.items.map((customer) => ({
          value: customer.id,
          label: `${customer.user.firstName} ${customer.user.lastName} - ${customer.merchant.name}`,
        }));
        this.setState({
          loading: false,
          customers,
          selectedCustomer: selectedCustomer || "",
        });
      }
    } catch (err) {
      console.error("Error fetching customers", err);
    }
  };

  // Fetches vehicles for the selected customer
  fetchVehicles = async () => {
    const { selectedCustomer } = this.state;
    if (!selectedCustomer || selectedCustomer === ":selectedCustomer") return;
    const pathname = `customers/${selectedCustomer}/Vehicle`;
    try {
      const response = await this.engine.getItem(pathname);
      if (response && response.status === 200) {
        const dataSource = response.data.items.map((item, key) => ({
          id: key,
          data: item,
          year: item.year,
          gcc: item.isGCC ? strings.yes : strings.no,
          plateCode: item.plateCode,
          plateNumber: item.plateNumber,
          make: item.make.name,
          model: item.model.name,
          trim: item.trim?.name,
          vin: item.vin,
          username: item.username,
          energy: strings[item.energy.toLowerCase()],
          user: `${item.customerUser.user.firstName} ${item.customerUser.user.lastName}`,
          created: new Date(item.createdAt),
          actions: this.renderActions(key, item),
        }));
        this.setState({ dataSource });
      }
    } catch (err) {
      console.error("Error fetching vehicles", err);
    }
    this.props.loadingAction(false);
  };
  callPage = () => {
    if (this.state.selectedCustomer) {
      this.fetchVehicles();
    }
  };

  // Renders the actions dropdown for each vehicle
  renderActions = (index, item) => {
    return (
      <RowActions
        actions={[
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  };

  // Handles the deletion of a vehicle
  handleDelete = async (valueid) => {
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const { selectedCustomer } = this.state;
      try {
        await this.engine.deleteItem(
          `customers/${selectedCustomer}/Vehicle`,
          valueid
        );
        this.fetchVehicles();
      } catch (err) {
        console.error("Error deleting vehicle", err);
      }
      this.props.loadingAction(false);
    }
  };

  // Handles editing of a vehicle
  handleEdit = (index, dataid) => {
    const data = this.state.dataSource[index].data;
    const { selectedMerchant, selectedCustomer } = this.state;
    if (!selectedMerchant || selectedMerchant === ":selectedMerchant") {
      alert(strings.select + " " + strings.merchant);
      return;
    }
    if (!selectedCustomer || selectedCustomer === ":selectedCustomer") {
      alert(strings.select + " " + strings.customer);
      return;
    }
    this.props.history.push({
      pathname: `/admin/customer_vehicles/${selectedCustomer}/edit/${dataid}`,
      state: { selectedMerchant, selectedCustomer },
      data,
    });
  };

  // Handles selecting a merchant
  handleMerchantSelect = (event) => {
    const selectedMerchant = event.value;
    if (selectedMerchant !== this.state.selectedMerchant) {
      this.setState(
        { selectedMerchant, selectedCustomer: "", customers: [] },
        this.fetchCustomers
      );
    }
  };
  // Updates selected merchant and fetches data
  handleCustomerSelect = (event) => {
    const selectedCustomer = event.value;
    this.setState({ selectedCustomer }, () => {
      this.props.history.push(`/admin/customer_vehicles/${selectedCustomer}`);
      this.callPage();
    });
  };

  // Handles adding a new vehicle
  handleAdd = () => {
    const { selectedMerchant, selectedCustomer } = this.state;
    if (!selectedMerchant || selectedMerchant === ":selectedMerchant") {
      alert(strings.select + " " + strings.merchant);
      return;
    }
    if (!selectedCustomer || selectedCustomer === ":selectedCustomer") {
      alert(strings.select + " " + strings.customer);
      return;
    }

    this.props.history.push({
      pathname: `/admin/customer_vehicles/${selectedCustomer}/add`,
      state: { selectedMerchant, selectedCustomer },
    });
  };

  render() {
    const {
      dataSource,
      isLoading,
      merchants,
      selectedMerchant,
      customers,
      selectedCustomer,
      canWrite,
    } = this.state;

    const columns = [
      { Header: strings.user, accessor: "user" },
      { Header: strings.make, accessor: "make" },
      { Header: strings.model, accessor: "model" },
      { Header: strings.trim, accessor: "trim" },
      { Header: strings.platecode, accessor: "plateCode" },
      { Header: strings.platenumber, accessor: "plateNumber" },
      { Header: strings.year, accessor: "year" },
      { Header: strings.energytype, accessor: "energy" },
      { Header: strings.vin, accessor: "vin" },
      { Header: strings.username, accessor: "username" },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="pull-left"></CardTitle>
                {canWrite && (
                  <Button
                    color="primary"
                    className="pull-right"
                    onClick={this.handleAdd}
                  >
                    {strings.add}
                  </Button>
                )}
                {!sessionStorage.getItem("merchantId") &&
                  merchants.length !== 1 && (
                    <SelectRow
                      label={strings.merchant}
                      name="selectedMerchant"
                      defaultValue={selectedMerchant}
                      data={merchants}
                      changeInput={this.handleMerchantSelect}
                      placeholder={strings.select}
                    />
                  )}
                <SelectRow
                  label={strings.customer}
                  name="selectedCustomer"
                  defaultValue={selectedCustomer}
                  data={customers}
                  changeInput={this.handleCustomerSelect}
                  placeholder={strings.select}
                />
              </CardHeader>
              <CardBody>
                <ReactTable
                  previousText={strings.previous}
                  nextText={strings.next}
                  loadingText={strings.loading}
                  noDataText={strings.nodata}
                  pageText={strings.page}
                  data={dataSource}
                  filterable
                  loading={isLoading}
                  columns={columns}
                  defaultPageSize={10}
                  showPaginationTop={false}
                  showPaginationBottom
                  PaginationComponent={TablePagination}
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});

export default connect(null, mapDispatchToProps)(CustomerVehiclesList);
